import { getPayment } from "./get-payment";

export const payment = {
    getPayment,
};
